import {useEffect} from 'react';

import {useViewportSize} from '../../../hooks';
import {getObjectValues} from '../../../utils';

function useMediaActions(data) {
    const {
        mediaEvents: {
            onSettingsChange
        },
        mediaOptions,
        initialMediaSettings,
        changeMediaSettings
    } = data;

    const viewportSize = useViewportSize();

    function setSettings(nextSettings) {
        changeMediaSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialMediaSettings);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialMediaSettings)]);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function calculateSettings() {
        const {
            smallBreakpoint,
            largeBreakpoint
        } = mediaOptions;

        const {
            width,
            height
        } = viewportSize;

        const isMobile = width < smallBreakpoint;
        const isTablet = width >= smallBreakpoint && width < largeBreakpoint;
        const isDesktop = width >= largeBreakpoint;

        const nextSettings = {
            width,
            height,
            isMobile,
            isTablet,
            isDesktop
        };

        setSettings(nextSettings);
    }, [...getObjectValues(mediaOptions), ...getObjectValues(viewportSize)]);
    /* eslint-enable react-hooks/exhaustive-deps */
}

export {useMediaActions};
